import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Card, DatePicker, Select, Spin } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import ImgIcon from '../../assets/png/defaultImgIcon.jpg'
import '../../style/page.css'
import { ArrowLeft, ImageUp } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSubscription } from '../../feature/subscription/subscriptionSlice';
import { editDaycare, getDaycare, getDaycareById } from '../../feature/dayCare/dayCareSlice';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from "dayjs";
import { disablePastDates } from '../../utils/DisableDate';
import ImageUpload from '../../utils/ImageUpload';
import { currencyData } from '../../constant/Constatnt';


function EditDaycare() {
    const [form] = Form.useForm();
    const { id } = useParams()
    const navigate = useNavigate()
    const [uploadStates, setUploadStates] = useState({});
    const [formData, setFormData] = useState(new FormData())
    const dispatch = useDispatch()
    const { allSubscriptionList } = useSelector((state) => state.subscriptions);
    const { actionLoader, isLoading, daycareById } = useSelector((state) => state.daycares);
    const [uploader, setUploader] = useState(null)

    const {
        daycareName,
        expiryDate,
        licenses,
        locationName,
        notes,
        currency,
        daycareProfile,
        numberOfStudents,
        numbersOfAdmins,
        numbersOfTeachers,
        ownerEmail,
        ownerPassword,
        ownerPhone,
        startDate,
        subScriptionId,
        _id,
    } = daycareById


    useEffect(() => {
        dispatch(getAllSubscription({}))
        dispatch(getDaycareById(id))
    }, [id])


    const onFinish = async (values) => {
        if (uploader) {
            values.daycareProfile.forEach((file) => {
                formData.append("daycareProfile", file.originFileObj);
            });
        }
        formData.append("daycareId", _id);
        formData.append("daycareName", values.daycareName);
        formData.append("locationName", values.locationName);
        formData.append("ownerEmail", values.ownerEmail);
        formData.append("ownerPhone", values.ownerPhone);
        formData.append("ownerPassword", values.ownerPassword);
        formData.append("startDate", values.startDate);
        formData.append("expiryDate", values.expiryDate);
        formData.append("subScriptionId", values.subScriptionId);
        formData.append("numbersOfAdmins", values.numbersOfAdmins);
        formData.append("numbersOfTeachers", values.numbersOfTeachers);
        formData.append("numberOfStudents", values.numberOfStudents);
        formData.append("currencyCode", values.currencyCode);
        formData.append("notes", values.notes);

        values.licenses?.forEach((point, index) => {
            formData.append(`licenses[${index}].documentName`, point.documentName); // also update to pointTexts
            point.documentImage?.forEach((img, imgIndex) => {
                const imageFile = img?.originFileObj || img?.file || null;
                if (imageFile instanceof File) {
                    formData.append(`licenses[${index}].documentImage[${imgIndex}]`, imageFile);
                } else {
                    console.warn(`No valid File found at points[${index}].pointImage[${imgIndex}]`);
                }
            });
        });

        const resultAction = await dispatch(editDaycare(formData));
        if (editDaycare.fulfilled.match(resultAction)) {
            await dispatch(getDaycare({}));
            setFormData(new FormData())
            navigate('/dashboard/daycare')
        } else {
            console.error("edit daycare");
        }

    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };


    useEffect(() => {
        if (licenses) {
            const formattedPoints = licenses.map((point, index) => ({
                documentName: point.documentName,
                documentImage: [
                    {
                        uid: `-${index}`,
                        name: point.documentImage?.split("\\").pop() || "", // extract filename safely
                        status: 'done',
                        url: point.documentImage?.replace(/\\/g, '/') || "", // fix backslashes
                    },
                ],
            }));

            form.setFieldsValue({
                daycareName,
                locationName,
                notes,
                numberOfStudents,
                numbersOfAdmins,
                numbersOfTeachers,
                ownerEmail,
                ownerPassword,
                ownerPhone,
                daycareProfile,
                currencyCode:currency.code,
                expiryDate: expiryDate ? dayjs(expiryDate, "DD-MM-YYYY") : null,
                startDate: startDate ? dayjs(startDate, "DD-MM-YYYY") : null,
                subScriptionId,
                licenses: formattedPoints,

            });

            // Set Upload state for each point
            const newUploadStates = {};
            formattedPoints.forEach((point, index) => {
                newUploadStates[index] = point.documentImage;
            });
            setUploadStates(newUploadStates);
        }
    }, [daycareById]);


    return (
        <section>
            {isLoading ? <Spin fullscreen /> : <Card title={
                <Space>
                    <ArrowLeft onClick={() => navigate(-1)} />
                    <h4>Edit  Daycare</h4>
                </Space>
            }>
                <Form
                    layout="vertical"
                    form={form}
                    name="add-service-form"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}

                >
                    <Row gutter={12}>
                        <Col xs={24} s={24} md={24} lg={12} >

                            <Form.Item
                                name="daycareName"
                                label="Daycare Name"
                                rules={[{ required: true, message: 'Please enter daycare name' }]}
                            >
                                <Input placeholder="Enter Daycare Name" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >
                            <Form.Item
                                name="locationName"
                                label="Location"
                                rules={[{ required: true, message: 'Please enter location' }]}
                            >
                                <Input placeholder="Enter Location" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >
                            <Form.Item
                                label="Owner Email"
                                name="ownerEmail"

                                rules={[{ required: true, message: 'Please enter ownerEmail' }]}
                            >
                                <Input type='email' placeholder="Enter Owner Email" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >

                            <Form.Item
                                name="ownerPhone"
                                label="Owner Phone"
                                rules={[{ required: true, message: 'Please enter owner phone' }, {
                                    pattern: /^[0-9]+$/,
                                    message: "Only numbers are allowed!",
                                },]}
                            >
                                <Input maxLength={10} placeholder="Enter Owner Phone" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >

                            <Form.Item
                                name="ownerPassword"
                                label="Owner Password"
                                rules={[{ required: true, message: 'Please enter owner password' }]}
                            >
                                <Input.Password placeholder="Enter Owner Password" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >

                            <Form.Item
                                name="numbersOfAdmins"
                                label="No. Of Admin"
                                rules={[{ required: true, message: 'Please enter number Of Admin' }, {
                                    pattern: /^[0-9]+$/,
                                    message: "Only numbers are allowed!",
                                },]}
                            >
                                <Input placeholder="Enter No. Of Admin" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >

                            <Form.Item
                                name="numbersOfTeachers"
                                label="No. Of Teacher"
                                rules={[{ required: true, message: 'Please enter number Of teacher' }, {
                                    pattern: /^[0-9]+$/,
                                    message: "Only numbers are allowed!",
                                },]}
                            >
                                <Input placeholder="Enter No. Of Teacher" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >
                            <Form.Item
                                label="No. Of Student"
                                name="numberOfStudents"
                                rules={[{ required: true, message: 'Please enter number Of Student' }, {
                                    pattern: /^[0-9]+$/,
                                    message: "Only numbers are allowed!",
                                },]}
                            >
                                <Input placeholder="Enter No. Of Student" size='large' />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >

                            <Form.Item
                                name="startDate"
                                label="Start Date"
                                rules={[{ required: true, message: 'Please enter start date' }]}
                            >
                                <DatePicker disabledDate={disablePastDates} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} s={24} md={24} lg={12} >
                            <Form.Item
                                name="expiryDate"
                                label="Expiry Date"
                                rules={[{ required: true, message: 'Please enter expiry date' }]}
                            >
                                <DatePicker disabledDate={disablePastDates} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col xs={24} s={24} md={24} lg={12} >
                            <Form.Item
                                name="subScriptionId"
                                label="Subscription"
                                rules={[{ required: true, message: 'Please select subscription' }]}
                            >
                                <Select placeholder="Select Subscription">
                                    {allSubscriptionList && allSubscriptionList?.map((item) => (
                                        <Select.Option key={item._id} value={item._id}>{item.planName}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                         <Col xs={24} s={24} md={24} lg={12} >
                            <Form.Item
                                name="currencyCode"
                                label="Currency Code"
                                
                                rules={[{ required: true, message: 'Please select currency code' }]}
                            >
                                <Select disabled placeholder="Select Currency Code">
                                    {currencyData?.map((item) => (
                                        <Select.Option key={item} value={item}>{item}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                        <Col xs={24} s={24} md={24} lg={24} >
                            <Form.Item
                                name="notes"
                                label="Notes"
                                rules={[{ required: true, message: 'Please enter notes' }]}
                            >
                                <Input.TextArea placeholder="Enter notes" size='large' />
                            </Form.Item>
                        </Col>
                    <Row gutter={12}>
                        <Col xs={24} s={24} md={24} lg={12} >
                            <Form.Item
                                name="daycareProfile"
                                label="Upload Logo  "
                                rules={[{ required: true, message: 'Please Upload logo ' }]}
                            >
                                <ImageUpload mode="edit" value={daycareProfile} onChange={(files) => setUploader(files[0])} type="single" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} s={24} md={24} lg={12} >
                            <Form.List
                                name="licenses"
                                rules={[{ required: true, message: 'Please upload documents' }]}

                            >
                                {(fields, { add, remove }, { errors }) => (
                                    <>
                                        {fields.map((field, index) => {
                                            const fileList = uploadStates[field.key] || [];

                                            const handleUploadChange = (info) => {
                                                setUploadStates((prev) => ({
                                                    ...prev,
                                                    [field.key]: info.fileList,
                                                }));
                                            };

                                            return (
                                                <div key={field.key} className="dynamic-form-item">
                                                    <Row gutter={16}>
                                                        {/* Text Input */}
                                                        <Col span={24}>
                                                            <Form.Item
                                                                label={`Document Name ${index + 1}`}
                                                                name={[field.name, 'documentName']}
                                                                rules={[{ required: true, message: 'Please enter document name' }]}
                                                            >
                                                                <Input placeholder="Enter Document Name" />
                                                            </Form.Item>
                                                        </Col>

                                                        {/* Image Upload */}
                                                        <Col span={24}>
                                                            <div className='dynamic_forms_input'>
                                                                <Form.Item
                                                                    label={index === 0 ? 'Choose File' : ''}
                                                                    name={[field.name, 'documentImage']}
                                                                    valuePropName="fileList"
                                                                    getValueFromEvent={(e) => Array.isArray(e) ? e : e?.fileList}
                                                                    rules={[{ required: true, message: 'Please upload an image!' }]}
                                                                >
                                                                    <Upload
                                                                        listType="picture"
                                                                        beforeUpload={() => false}
                                                                        accept=".jpg,.jpeg,.png"
                                                                        fileList={fileList}
                                                                        onChange={handleUploadChange}
                                                                        maxCount={1}
                                                                    >
                                                                        {fileList.length < 1 && (
                                                                            <Button icon={<ImageUp />}>Choose File</Button>
                                                                        )}
                                                                    </Upload>
                                                                </Form.Item>
                                                                {fields.length > 1 && (
                                                                    <MinusCircleOutlined
                                                                        style={{ fontSize: '18px', color: 'red' }}
                                                                        onClick={() => remove(field.name)}
                                                                    />
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })}
                                        {/* Add Point Button */}
                                        <Form.Item>
                                            <Button
                                                type="dashed"
                                                onClick={() => add()}
                                                block
                                                icon={<PlusOutlined />}
                                            >
                                                Add  Document
                                            </Button>
                                            <Form.ErrorList errors={errors} />
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </Col>
                    </Row>
                    <Form.Item  >
                        <div className='submit_btn'>
                            <Space>
                                <Button type="primary" loading={actionLoader} htmlType="submit">
                                    Submit
                                </Button>
                                <Button danger htmlType="button" onClick={handleCancel}>
                                    Reset
                                </Button>
                            </Space>
                        </div>
                    </Form.Item>
                </Form >
            </Card>}
        </section>
    );
}



export default EditDaycare